import { forwardRef } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface CheckboxFieldProps {
  label: string;
  name: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  error?: string;
  required?: boolean;
  className?: string;
}

const CheckboxField = forwardRef<HTMLButtonElement, CheckboxFieldProps>(
  ({ label, name, checked, onChange, error, required, className }, ref) => {
    return (
      <div className={className}>
        <div className="flex items-center space-x-2">
          <Checkbox
            ref={ref}
            id={name}
            checked={checked}
            onCheckedChange={onChange}
            className={error ? "border-red-500 ring-1 ring-red-400" : ""}
          />
          <Label
            htmlFor={name}
            className="text-sm text-slate-600 cursor-pointer"
          >
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </Label>
        </div>
        {error && <p className="text-red-500 text-xs mt-1 pl-6">{error}</p>}
      </div>
    );
  }
);

CheckboxField.displayName = "CheckboxField";

export default CheckboxField;
